import { Cookies } from 'react-cookie'

export const localeCookieName = `locale`

export const getLocaleCookie = (): string | null => {
  const cookieInstance = new Cookies()
  return cookieInstance.get(localeCookieName) as string | null
}
